<script>
import Layout from "@layouts/form";
import ChamadoPrioridade from "@forms/ChamadoPrioridade";

export default {
  page: {
    title: "Detalhes | Chamado Prioridade"
  },
  components: { Layout, ChamadoPrioridade },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Chamado Prioridade",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Chamado Prioridade",
          href: "/ChamadoPrioridade"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ChamadoPrioridade :editable="editable"></ChamadoPrioridade>
    </div>
  </Layout>
</template>
